import React from "react";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const PublicLayout = () => {
  const location = useLocation();
  const accessToken = Cookies.get("AccessToken");

  if (accessToken) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  return (
    <div className="page bg-gary1">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default PublicLayout;
